import React from "react";
import TextField from "@material-ui/core/TextField";
import { Controller } from "react-hook-form";

export default function TextFieldController(props) {
  //  //console.log("TextField Controller Here ", props)
  return (
    <Controller
      as={
        <TextField
          type={props.type}
          inputProps={props.InputProps}
          style={props.style}
          fullWidth
          disabled={props.disabled}
          multiline={props.multiline}
          error={props.error}
          required={props.required}
          label={props.label}
          placeholder={props.placeholder}
          InputLabelProps={props.InputLabelProps}
          variant="outlined"
          size="small"
          minRows={props.multiline ? props.minRows : undefined}
          onChange={(event) => {
            try {
              //console.log(" TextField Chnaged is defined");
              props.getValueChanged(event[0].currentTarget.value);
            } catch {
              //console.log(" TextField getvalueChnaged is not defined");
            }
          }}
          // value={props.value || ""}
        />
      }
      onKeyUp={props.onKeyUp}
      defaultValue={props.defaultValue}
      name={props.name}
      control={props.control}
      rules={props.rules}
      onBlur={props.onBlur}
    />
  );
}
